<template>
  <div class="NavBarMedia">
    <span
    class="NavBarMedia__title"
    @click="activateTab('all')">
      Media
    </span>
    <div class="NavBarMedia__menu">
      <span
      class="NavBarMedia__tab"
      :class="{'NavBarMedia__tab--active': isActiveTab('all')}"
      @click="activateTab('all')">
        All
      </span>
      <span
      class="NavBarMedia__tab"
      :class="{'NavBarMedia__tab--active': isActiveTab('photo')}"
      @click="activateTab('photo')">
        Photos
      </span>
      <span
      class="NavBarMedia__tab"
      :class="{'NavBarMedia__tab--active': isActiveTab('video')}"
      @click="activateTab('video')">
        Videos
      </span>
      <span
      class="NavBarMedia__tab"
      :class="{'NavBarMedia__tab--active': isActiveTab('audio')}"
      @click="activateTab('audio')">
        Audios
      </span>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'NavBarMedia',

  computed: {
    ...mapGetters('filesMedia', [
      'activeTab'
    ])
  },

  methods: {
    ...mapActions('filesMedia', [
      'activateTab'
    ]),
    isActiveTab (tab) {
      return this.activeTab === tab
    }
  }
}
</script>

<style lang="scss">
@import 'NavBarMedia';
</style>
